import { render, staticRenderFns } from "./relationconsum.vue?vue&type=template&id=42cb9eb7&scoped=true&"
import script from "./relationconsum.vue?vue&type=script&lang=js&"
export * from "./relationconsum.vue?vue&type=script&lang=js&"
import style0 from "./relationconsum.vue?vue&type=style&index=0&id=42cb9eb7&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42cb9eb7",
  null
  
)

export default component.exports